import { useContext, useEffect, useRef, useState } from "react"
import { AppContext } from "../../context/context"
import { useNavigate, useParams } from "react-router-dom"
import UiButton3 from "../../components/ui_button3"
import moment from "moment"
import UiSpinner from "../../components/ui_spinner"

const BrandGoalsNumber = ({ x, xx }) => {

    const [value, setValue] = useState(null)

    function numberWithCommas(xxx) {
        let num = xxx.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        setValue(num)
        return num
    }

    useEffect(() => {
        try {
            numberWithCommas(xx.toFixed(2))
        }
        catch (err) {
            setValue(xx)
        }
    }, [])

    return (
        <span className="align-self-center">{value}</span>
    )
}

const BrandGoals = () => {

    const navigate = useNavigate()
    const { id } = useParams()
    const {
        ww,
        neonUser,
        brand, setBrand,
        marketplaceList,
        getMarketPlace,
        offCanvas,
        setPopupSidebarType,
        setSideBarTitle,
        selectedYearMarketplace, setSelectedYearMarketplace,
        reloadYearMarketplace, setReloadYearMarketplace,
        fetchDataV2
    } = useContext(AppContext)

    const [load, setLoad] = useState(true)
    const [addLoading, setAddLoading] = useState(false)
    const [yearList, setYearList] = useState([])
    const [selectedYear, setSelectedYear] = useState("")
    const [goalList, setGoalList] = useState([])
    const [selectedGoal, setSelectedGoal] = useState(null)
    const [selectedMarketPlace, setSelectedMarketPlace] = useState("")
    const [yearMarketplaceListOriginal, setYearMarketplaceListOriginal] = useState([])
    const [yearMarketplaceList, setYearMarketplaceList] = useState([])
    const [yearMarketplaceGoalData, setYearMarketplaceGoalData] = useState([])
    const [message, setMessage] = useState({ type: "", text: "" })
    const [goalsEditing, setGoalsEditing] = useState(false)
    const [selectedCell, setSelectedCell] = useState({})
    const [existingMarketplace, setExistingMarketplace] = useState([])

    const cellInput = useRef(null)

    const getExistingMarketplace = async () => {
        let query1 = "GET_EXISTING_MARKETPLACE", params1 = [brand.brand_entity_id]
        try {
            let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
            resp = marketplaceList.filter(x => resp.map(x => Number(x.marketplace_id)).includes(x.id))
            setExistingMarketplace(resp)
        }
        catch (err) {
            return
        }
    }

    const getGoalList = async () => {
        let query1 = "GET_GOAL_LIST", params1 = []
        try {
            let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
            setGoalList(resp)
        }
        catch (err) {
            return
        }
    }

    const selectGoal = (id) => {
        let goal = goalList.filter(x => x.id == id)[0]
        setSelectedGoal(goal)
    }

    const addGoal = async () => {
        setMessage({ type: "", text: "" })
        if (!selectedYearMarketplace || !selectedGoal) {
            setMessage({ type: "danger", text: "You must select a goal." })
            return
        }

        let query1 = ["$", "%"].includes(selectedGoal.type) ?
            "ADD_GOAL_NUMERIC" :
            "ADD_GOAL_STRING",
            params1 = [selectedYearMarketplace.id, selectedGoal.id]

        try {
            await fetchDataV2(query1, params1, "/neon-query-v2")
            setSelectedGoal(null)
            getGoalData()
        }
        catch (err) {
            return
        }
    }

    const getGoalData = async () => {
        let query1 = "GET_GOAL_DATA", params1 = [selectedYearMarketplace.country_code, selectedYearMarketplace.brand_id, selectedYearMarketplace.year]
        try {
            let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
            let newData = [7, 8, 9, 10]
                .map(x => resp.filter(xx => xx.id == x)[0])
                .filter(x => x !== undefined);
            setYearMarketplaceGoalData(newData)
        }
        catch (err) {
            return
        }
    }

    const getBrandInfo = async () => {
        setLoad(true)
        let query1 = ["admin", "owner"].includes(neonUser.user.role) ?
            "GET_BRAND_INFO_ADMIN" : "GET_BRAND_INFO",
            params1 = [id, neonUser.user.agency_id]
        try {
            let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
            if (resp.length == 0) {
                navigate("/brand")
                return
            }
            setBrand(resp[0])
        }
        catch (err) {
            navigate("/brand")
        }
        finally {
            setLoad(false)
        }
    }

    const createYearList = () => {
        function* range(start, end, step) {
            while (start < end) {
                yield start;
                start += step;
            }
        }
        let currentYear = Number(moment().format("YYYY"))
        let years = Array.from(range(currentYear, currentYear + 2, 1));
        setYearList(years)
    }

    const addYearMarketplace = async () => {
        setAddLoading(true)
        setLoad(true)
        setMessage({ type: "", text: "" })

        if (selectedMarketPlace == "" || selectedYear == "") {
            setMessage({ type: "danger", text: "Marketplace and Year required." })
            setAddLoading(false)
            setLoad(false)
            return
        }

        let query1 = "ADD_YEAR_MARKETPLACE", params1 = [selectedMarketPlace, selectedYear, brand.id, brand.agency_id]
        let return_id = null, brand_year_marketplace = null

        try {
            let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
            return_id = resp[0].id
            brand_year_marketplace = resp[0]
        }
        catch (err) {
            setLoad(false)
            setAddLoading(false)
            return
        }

        if (!return_id) return;

        try {
            let resp2 = await Promise.all([7, 8, 9, 10].map(goalId => fetchDataV2("ADD_GOAL_NUMERIC", [return_id, goalId], "/neon-query-v2")))
            let allRows = resp2.flat()
            await writeTobigQuery(allRows, brand_year_marketplace)
            setSelectedMarketPlace("")
            setSelectedYear("")
            getYearMarketplace()
            setMessage({ type: "success", text: "Year added successfully." })
            setLoad(false)
            setAddLoading(false)
        }
        catch (err) {
            setLoad(false)
            setAddLoading(false)
            return
        }
    }

    const getYearMarketplace = async () => {
        let query1 = "GET_YEAR_MARKETPLACE", params1 = [brand.id, brand.agency_id]
        try {
            let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
            setYearMarketplaceListOriginal(resp)
            let countryCode = [...new Set(resp.map(({ country_code }) => country_code))]
            countryCode = countryCode.map(x => ({
                country_code: x,
                years: ([...new Set(resp
                    .filter(({ country_code }) => country_code == x)
                    .map(({ year, id }) => ({ year, id })))])
                    .sort((a, b) => a.year - b.year)
            }))
            setYearMarketplaceList(countryCode)
        }
        catch (err) {
            return
        }
    }

    const deleteYear = () => {
        if (!selectedYearMarketplace) return;
        offCanvas.show()
        setPopupSidebarType("delete_year_marketplace")
        setSideBarTitle("Delete Year Goal")
    }

    const selectYearMarketplace = (id) => {
        setMessage({ type: "", text: "" })
        let found = yearMarketplaceListOriginal.filter(x => x.id == id)[0]
        setSelectedYearMarketplace(found)
    }

    const yearMarketplaceDataChangeHandler = (x, ii, e) => {
        setYearMarketplaceGoalData(yearMarketplaceGoalData.map(xx => {
            if (xx.brand_goals_id == x.brand_goals_id) {
                return {
                    ...xx,
                    months_data: (() => {
                        let arr = xx.months_data
                        arr[ii] = e.target.value.replace(/^0+/, '')
                        arr[ii] = ["$", "%"].includes(x.type) ? Number(arr[ii]) : arr[ii]
                        return arr
                    })()
                }
            }
            else return xx
        }))
    }

    const resetData = () => {
        setMessage({ type: "", text: "" })
        setSelectedYearMarketplace(null)
        setYearMarketplaceGoalData([])
    }

    const editGoalData = async () => {
        setMessage({ type: "", text: "" })
        setLoad(true)
        try {
            let resps = await Promise.all(yearMarketplaceGoalData.map(x => {
                let query1 = "UPDATE_GOAL_DATA", params1 = [JSON.stringify(x.months_data.map(xx => ['$', ' % '].includes(x.type) ? Number(xx) : xx)), x.brand_goals_id]
                return fetchDataV2(query1, params1, "/neon-query-v2")
            }))
            writeTobigQuery(resps.map(x => x[0]), selectedYearMarketplace, "edit")
            setMessage({ type: "success", text: "Goals data updated succesfully." })
        }
        catch (err) {
            setMessage({ type: "error", text: "Somethin went wrong: " + err })
            return
        }
        finally {
            setLoad(false)
        }
    }

    const deleteBrandGoal = async (x) => {
        let query1 = "DELETE_BRAND_GOAL", params1 = [x.brand_goals_id]
        try {
            await fetchDataV2(query1, params1, "/neon-query-v2")
            getGoalData()
        }
        catch (err) {
            return
        }
    }

    const selectedCellChangeHandler = (x, e) => {
        setSelectedCell(x)
        setTimeout(() => {
            cellInput.current.focus()
        }, 100)
    }

    const writeTobigQuery = async (monthly_data, brand_year_marketplace, type) => {
        let query1 = "GET_GOALS_BY_IDS", params1 = [monthly_data.map(x => x.goal_id)]
        let resp = await fetchDataV2(query1, params1, "/neon-query-v2")

        monthly_data = monthly_data.map(x => ({
            goal: resp.filter(xx => xx.id == x.goal_id)[0].goal,
            ...x
        }))

        let data = {
            monthly_data,
            brand_year_marketplace,
            brand,
            agency: neonUser.agency,
            marketplace: marketplaceList.filter(x => x.countrycode == (type == "edit" ? brand_year_marketplace.country_code : selectedMarketPlace))[0]
        }

        try {
            await fetchDataV2("DELETE_GOAL_BQ", {
                ids: monthly_data.map(x => x.id)
            }, "/bigquery-sql-v2")

            await fetchDataV2("INSERT_GOAL_BQ", {
                monthly_data: monthly_data.map(x => ({
                    id: x.id,
                    goal: x.goal,
                    months_data: x.months_data
                })),
                agency: data.agency,
                brand: data.brand,
                marketplace: data.marketplace,
                year: data.brand_year_marketplace.year,
                brand_year_marketplace_id: data.brand_year_marketplace.id
            }, "/bigquery-sql-v2")
        }
        catch (err) {
            return
        }
    }

    useEffect(() => {
        if (marketplaceList.length == 0) getMarketPlace();
        if (marketplaceList.length > 0 && brand && brand.id) getExistingMarketplace()
    }, [marketplaceList, brand])

    useEffect(() => {
        if (id && neonUser) getBrandInfo()
    }, [neonUser])

    useEffect(() => {
        if (brand && brand.id) getYearMarketplace()
    }, [brand])

    useEffect(() => {
        if (selectedYearMarketplace) getGoalData()
    }, [selectedYearMarketplace])

    useEffect(() => {
        setSelectedYear("")
    }, [selectedMarketPlace])

    useEffect(() => {
        if (reloadYearMarketplace) {
            setReloadYearMarketplace(false)
            getYearMarketplace()
        }
    }, [reloadYearMarketplace])

    useEffect(() => {
        createYearList()
        getGoalList()
        setSelectedYearMarketplace(null)
    }, [])

    return (
        <>
            <div className={" d-flex flex-column gap-3 " + (ww < 400 ? "px-1 pt-4" : "p-4")}>
                <div className={`d-flex ${ww < 400 ? "flex-column gap-2 px-1" : "justify-content-between"}`}>
                    <div className="d-flex gap-2">
                        <UiButton3 submit={() => { navigate(-1) }} />
                        <p className="mb-0 align-self-center fs-4 text-capitalize">
                            Goals {">"} {brand && brand.brand}
                            {selectedYearMarketplace && ` > ${selectedYearMarketplace.country_code} > ${selectedYearMarketplace.year} `}
                        </p>
                    </div>
                </div>
                <div className="container1 d-flex flex-column gap-4">
                    {selectedYearMarketplace ?
                        <>
                            <div>
                                <p className="poppins fw-bold mb-1">Goals Data</p>
                                {message.text && <p className={`poppins text-${message.type}`}>{message.text}</p>}
                                <div className="d-flex w-100 mb-2">
                                    <div style={{ width: 200 }}>
                                        <table className="table table-bordered m-0">
                                            <tbody className="poppins">
                                                <tr>
                                                    <th style={{ height: 40 }}>MONTH</th>
                                                </tr>
                                                {yearMarketplaceGoalData.map((x, i) => (
                                                    <tr key={i}>
                                                        <td title={x.goal} style={{ height: 40 }}>
                                                            <div className="text-truncate d-flex gap-1">
                                                                {goalsEditing && <i onClick={() => deleteBrandGoal(x)} style={{ color: " #650260", cursor: "pointer" }} className="bi bi-trash3-fill"></i>}
                                                                {brand.account_type == 'vendor' && x.id == 7 ? <span>{x.goal.split("/")[1]}</span> : <span>{x.goal.split("/")[0]}</span>}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="w-100" style={{ overflowX: 'auto' }}>
                                        <table className="table d-flex table-bordered m-0">
                                            <tbody>
                                                <tr className="poppins">
                                                    {moment.monthsShort().map((x, i) =>
                                                        <th key={i} style={{ minWidth: 100, height: 40 }} className="text-center">{x.toUpperCase()}</th>
                                                    )}
                                                </tr>
                                                {yearMarketplaceGoalData.map((x, i) => (
                                                    <tr key={i}>
                                                        {x.months_data.map((xx, ii) => (
                                                            <td style={{ height: 40.8 }} key={ii} className="p-0">
                                                                {selectedCell.brand_goals_id == x.brand_goals_id && selectedCell.index == ii ?
                                                                    <div className="w-100 h-100 d-flex poppins">
                                                                        <input
                                                                            ref={cellInput}
                                                                            className={"w-100 " + (x.type == "%" && " ms-1")}
                                                                            style={{ border: 'none' }}
                                                                            value={xx}
                                                                            type={['$', '%'].includes(x.type) ? 'number' : 'text'}
                                                                            onBlur={() => setSelectedCell({})}
                                                                            onKeyDownCapture={e => {
                                                                                if (e.key == "Enter") {
                                                                                    yearMarketplaceDataChangeHandler(x, ii, e)
                                                                                    e.target.blur()
                                                                                    return
                                                                                }
                                                                                if (e.key == "Escape") {
                                                                                    e.target.blur()
                                                                                    return
                                                                                }
                                                                            }}
                                                                            onChange={(e) => {
                                                                                e.target.value = e.target.value.replace(/^0+/, '')
                                                                                yearMarketplaceDataChangeHandler(x, ii, e)
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    :
                                                                    <div className="d-flex w-100 h-100 justify-content-end px-2 poppins" onClick={(e) => selectedCellChangeHandler({ ...x, index: ii })}>
                                                                        {x.type == "$" && <span className="align-self-center ms-1">{x.type}</span>}
                                                                        <BrandGoalsNumber x={x} xx={xx} />
                                                                        {x.type == "%" && <span className="align-self-center me-1">{x.type}</span>}
                                                                    </div>
                                                                }
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between">
                                    {goalsEditing ?
                                        <p onClick={() => setGoalsEditing(false)} style={{ backgroundColor: ' #650260', borderRadius: 20, cursor: 'pointer' }} className="px-3 text-white align-self-center py-1 mb-0">Ok</p>
                                        :
                                        <>
                                            {load ?
                                                <UiSpinner />
                                                :
                                                <p onClick={load ? null : editGoalData} style={{ backgroundColor: ' #650260', borderRadius: 20, cursor: 'pointer' }} className="px-3 text-white align-self-center py-1 mb-0">Save</p>
                                            }
                                            <div className="d-flex gap-1">
                                                <div onClick={deleteYear} className="d-flex gap-2 px-3" style={{ cursor: 'pointer', border: '1px solid  #650260', borderRadius: 20 }}>
                                                    <p className="mb-0 align-self-center">Delete</p>
                                                </div>
                                                <p onClick={resetData} style={{ backgroundColor: ' #650260', borderRadius: 20, cursor: 'pointer' }} className="px-3 text-white align-self-center py-1 mb-0">Close</p>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <div className="w-100">
                                <div>
                                    <p className="poppins fw-bold mb-1">Marketplace</p>
                                    {message.text && <p className={`poppins text-${message.type}`}>{message.text}</p>}
                                </div>
                                <div className="d-flex gap-1">
                                    <select value={selectedMarketPlace} onChange={(e) => setSelectedMarketPlace(e.target.value)} style={{ height: 25, borderRadius: 20 }} className="px-2">
                                        <option value={""}>{`- select -`}</option>
                                        {existingMarketplace.length > 0 && existingMarketplace.map((x) => (
                                            <option key={x.id} value={x.countrycode}>{x.countrycode}</option>
                                        ))}
                                    </select>

                                    <select disabled={!selectedMarketPlace} value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)} style={{ height: 25, borderRadius: 20 }} className="px-2">
                                        <option value={""}>{`- select -`}</option>
                                        {yearMarketplaceList.length > 0 && yearList.length > 0 ?
                                            yearList
                                                .filter(x => {
                                                    let arr = []
                                                    arr = yearMarketplaceList.filter(xx => xx.country_code == selectedMarketPlace)
                                                    if (arr.length > 0) {
                                                        arr = arr[0].years.map(xx => xx.year)
                                                        arr = !arr.includes(x)
                                                    }
                                                    return arr
                                                })
                                                .map(x => (
                                                    <option key={x} value={x}>{x}</option>
                                                ))
                                            :
                                            yearList.map(x => (
                                                <option key={x} value={x}>{x}</option>
                                            ))
                                        }
                                    </select>
                                    {addLoading ?
                                        <UiSpinner />
                                        :
                                        <p onClick={load ? null : addYearMarketplace} style={{ backgroundColor: ' #650260', borderRadius: 20, cursor: 'pointer' }} className="px-3 text-white align-self-center">Add</p>
                                    }
                                </div>
                                <div className="w-100 d-flex gap-2" style={{ overflowX: 'auto' }}>
                                    <div className="table-responsive">
                                        <table className="table table-bordered">
                                            <tbody>
                                                {yearMarketplaceList.length > 0 && yearMarketplaceList.map((x, i) => (
                                                    <tr key={i}>
                                                        <th>{x.country_code}</th>
                                                        <td>
                                                            <div className="d-flex gap-2">
                                                                {x.years.map((xx) => (
                                                                    <div key={xx.id} onClick={() => selectYearMarketplace(xx.id)} className="d-flex gap-2 px-2" style={{ cursor: 'pointer', border: '1px solid  #650260', borderRadius: 20 }}>
                                                                        <p className="mb-0">{xx.year}</p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    {yearMarketplaceList.length == 0 && <p className="text-secondary poppins">No marketplace data yet...</p>}
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    )
}

export default BrandGoals